import { useEffect, useState, useSyncExternalStore } from 'react'
import { RoomConnection } from './network'

export function useRoom(roomId: string) {
  const [connection] = useState(() => new RoomConnection(roomId))
  const state = useSyncExternalStore(connection.subscribe, connection.getSnapshot, connection.getSnapshot)
  useEffect(() => { connection.start(); return () => connection.stop() }, [connection])
  return { ...state, connection }
}
